module.exports = __webpack_public_path__ + "static/img/zlwls.c79b0522.png";